const release = '0.11.1'

module.exports = { release }



// WEBPACK FOOTER //
// ./release.js